export const TrackingInfo = {
  dataCategory: "Menu",
  dataAction: "click",
  dataLabel: ""
};
